export const shirtSizes = ['PP', 'P', 'M', 'G', 'GG', 'XGG']

export const genderOptions = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Feminino' },
  { value: 'other', label: 'Outro' },
]

export const emergencyRelationships = [
  { value: 'parent', label: 'Pai / Mãe' },
  { value: 'child', label: 'Filho(a)' },
  { value: 'spouse', label: 'Cônjuge / Companheiro(a)' },
  { value: 'brother', label: 'Irmão(ã)' },
  { value: 'friend', label: 'Amigo(a)' },
  { value: 'other', label: 'Outro' },
]
